import React from 'react'
import PropTypes from 'prop-types'
import ButtonSetting from '../ButtonSetting'
import { launcherOpenCacheDialog } from '../../../../imports'

const SharedCache = (props) => {
    const settings = {
        label: props.label,
        onClick: () => launcherOpenCacheDialog(),
    }

    return <ButtonSetting {...settings} />
}

SharedCache.propTypes = {
    label: PropTypes.string,
}

export default SharedCache



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/SharedCache/component.js